export type TaskCategoryScope = "company" | "personal";

export class TaskCategory {
  category_id: string;
  eva_company_id: string;
  name: string;
  color: string;
  icon: string;
  is_default: boolean;
  order: number;
  scope: TaskCategoryScope; // "company" ou "personal"
  created_by: string; // employee_id du createur (si scope=personal)
  is_deleted: boolean; // soft-delete
  created_at: Date;

  constructor() {
    this.category_id = "";
    this.eva_company_id = "";
    this.name = "";
    this.color = "";
    this.icon = "";
    this.is_default = false;
    this.order = 0;
    this.scope = "company";
    this.created_by = "";
    this.is_deleted = false;
    this.created_at = null;
  }

  static createInstance(data: any): TaskCategory {
    const c = Object.assign(new TaskCategory(), data);
    if (data.created_at) c.created_at = new Date(data.created_at);
    return c;
  }

  static createInstances(data: any[]): TaskCategory[] {
    return (data || []).map(TaskCategory.createInstance);
  }

  /** Verifie si la categorie est personnelle */
  isPersonal(): boolean {
    return this.scope === "personal";
  }

  /** Verifie si la categorie est visible (non supprimee) */
  isVisible(): boolean {
    return !this.is_deleted;
  }
}
